import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, ChevronLeft } from "lucide-react";
import { API } from "@/constants";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const MarketingServicesPage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/services/marketing/packages`);
        setPackages(res.data.packages || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
  
  return (
    <main className="min-h-screen bg-slate-50" data-testid="marketing-services-page">
      <Disclaimer />
      <div className="container-shell py-8 max-w-6xl">
        <div className="mb-6">
          <Link to="/tools/services-hub" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1 mb-4">
            <ChevronLeft className="h-4 w-4" /> Back to Services Hub
          </Link>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Fraunces', serif" }}>Marketing Services</h1>
          <p className="text-muted-foreground">Client acquisition programs, PPC, SEO, and corporate development</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {packages.map((pkg, i) => (
            <Card key={i} className={pkg.id === 'scale' ? "border-blue-300 ring-1 ring-blue-200" : ""}>
              <CardContent className="p-5">
                {pkg.id === 'scale' && <Badge className="mb-2 bg-blue-600">POPULAR</Badge>}
                <h3 className="font-semibold text-lg mb-1">{pkg.name}</h3>
                <p className="text-3xl font-bold mb-2">${pkg.monthly_cost}<span className="text-sm font-normal text-muted-foreground">/mo</span></p>
                <p className="text-sm text-emerald-600 font-medium mb-4">{pkg.leads_expected} leads</p>
                <ul className="text-sm space-y-1 mb-4">
                  {pkg.includes?.map((item, j) => (
                    <li key={j} className="flex items-center gap-2">
                      <CheckCircle2 className="h-3 w-3 text-emerald-500" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Button className="w-full" variant={pkg.id === 'scale' ? "default" : "outline"}>
                  Get Started
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
};


export default MarketingServicesPage;
